export default {"src":"/_next/static/media/layout.5c31feba.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};